import { AppState } from '../reducer';
import { ReferralsEntities } from './types';

export const referrer$ = (state: AppState) => state.referrals[ReferralsEntities.REFERRER];

export const referrals$ = (state: AppState) => state.referrals[ReferralsEntities.REFERRALS];
